import deepmerge from 'deepmerge';
import { AbstractFacade } from '@goparrot/axios';
import { plainToInstanceWithLVS } from '@goparrot/common';
import { stringify } from 'qs';
import { ReadLoyaltyProgramDto } from '../generated-dto';
import { LoyaltyProgramExposeGroupEnum } from '../interface';
export class LoyaltyProgramFacade extends AbstractFacade {
    constructor(config = {}, interceptors = {}) {
        const IFacadeConfig = {
            axiosConfig: {
                baseURL: process.env.GOPARROT_PLATFORM_SERVICE_LOYALTY_POINTS,
                paramsSerializer: stringify,
            },
        };
        super(deepmerge.all([IFacadeConfig, config]), interceptors);
    }
    async list(merchantId, params) {
        const response = await this.client.get(`/api/v2/merchants/${merchantId}/programs`, {
            params,
        });
        return plainToInstanceWithLVS(ReadLoyaltyProgramDto, response.data, {
            groups: [LoyaltyProgramExposeGroupEnum.READ],
        });
    }
    async get(merchantId, programUuid) {
        const response = await this.client.get(`/api/v2/merchants/${merchantId}/programs/${programUuid}`);
        return plainToInstanceWithLVS(ReadLoyaltyProgramDto, response.data, {
            groups: [LoyaltyProgramExposeGroupEnum.READ],
        });
    }
    async create(merchantId, data) {
        const response = await this.client.post(`/api/v2/merchants/${merchantId}/programs`, data);
        return plainToInstanceWithLVS(ReadLoyaltyProgramDto, response.data, {
            groups: [LoyaltyProgramExposeGroupEnum.READ],
        });
    }
    async update(merchantId, programUuid, data) {
        const response = await this.client.put(`/api/v2/merchants/${merchantId}/programs/${programUuid}`, data);
        return plainToInstanceWithLVS(ReadLoyaltyProgramDto, response.data, {
            groups: [LoyaltyProgramExposeGroupEnum.READ],
        });
    }
    async delete(merchantId, programUuid) {
        await this.client.delete(`/api/v2/merchants/${merchantId}/programs/${programUuid}`);
    }
}
//# sourceMappingURL=LoyaltyProgramFacade.js.map